import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-background border-t border-border p-6 shadow-2xl">
      <div className="container mx-auto max-w-6xl flex flex-col lg:flex-row items-center justify-between gap-8">
         <p className="text-sm text-muted-foreground font-light leading-relaxed lg:w-[60%]">
           A weboldalunk sütiket (cookie-kat) használ a jobb felhasználói élmény, a látogatottság mérése és a hirdetések személyre szabása érdekében. Részletes információk az <Link to="/adatkezelesi-tajekoztato" target="_blank" className="text-foreground underline underline-offset-4 hover:text-accent font-medium transition-colors">Adatkezelési tájékoztató</Link> és a <Link to="/cookie-tajekoztato" target="_blank" className="text-foreground underline underline-offset-4 hover:text-accent font-medium transition-colors">Süti tájékoztató</Link> oldalakon találhatók.
         </p>
         <div className="flex flex-col sm:flex-row gap-4 items-center w-full lg:w-auto">
            <Link to="/cookie-tajekoztato" className="text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors mr-2 sm:mr-4 border-b border-transparent hover:border-foreground">Beállítások</Link>
            <Button variant="outline" size="sm" onClick={handleAcceptNecessary} className="w-full sm:w-auto text-[10px] h-10 px-6 border-border text-foreground hover:bg-secondary">Csak a szükségesek</Button>
            <Button size="sm" onClick={handleAcceptAll} className="w-full sm:w-auto text-[10px] h-10 px-6 bg-foreground text-background hover:bg-foreground/90">Összes elfogadása</Button>
         </div>
      </div>
    </div>
  );
};

export default CookieBanner;
